// removed by extract-text-webpack-plugin
module.exports = {"resource-list":"resource-list__1oJJG","title":"title__sNEDm","sub-title":"sub-title__QYYfD","list":"list__yhmQf","clear-left":"clear-left__y9n5e","clear-right":"clear-right__31597","left":"left__1zD0A"};


//////////////////
// WEBPACK FOOTER
// ./styles/homePage/resourceList.scss
// module id = 741
// module chunks = 68